import { render, staticRenderFns } from "./gsr_ktxm_report.vue?vue&type=template&id=38e0ec58&scoped=true"
import script from "./gsr_ktxm_report.vue?vue&type=script&lang=js"
export * from "./gsr_ktxm_report.vue?vue&type=script&lang=js"
import style0 from "./gsr_ktxm_report.vue?vue&type=style&index=0&id=38e0ec58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0ec58",
  null
  
)

export default component.exports